module.exports = __webpack_public_path__ + "img/f107bab.jpg";